export default __webpack_public_path__ + "static/media/share-icon.2ad3fca2.svg";